<div class="home">
    <div class="left">
        <h2>OrgDrobe</h2>
        <p>Prepare. Put on. Enjoy</p>
        <button mat-raised-button color="accent" routerLink="/signup">Get started!</button>
        <p class="link" >or
            <a routerLink="/discover">look around</a>
        </p>
    </div>
    <div class="right"></div>
</div>